import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';

import { GlassCard } from '../../../../../../components/glass';
import type { IContaCilLancamentoResumo } from '../../../../../../hooks/useContaCilLancamentos';
import { fmtValor } from '../shared';

const SEG = [
  { key: 'soma_conciliado' as const, label: 'conciliado', cor: '#10B981' },
  { key: 'soma_pendente' as const, label: 'pendente', cor: '#F59E0B' },
  { key: 'soma_revisao' as const, label: 'revisão', cor: '#8B5CF6' },
];

/**
 * Barra de progresso da conciliação POR VALOR (R$) — não por contagem.
 * Mostra quanto do volume já está conciliado vs pendente vs revisão.
 */
export function ProgressoConciliacao({ resumo }: { resumo: IContaCilLancamentoResumo }) {
  const total = resumo.soma_total || 0;
  const pct = (v: number) => (total > 0 ? (v / total) * 100 : 0);
  const pctConc = Math.round(pct(resumo.soma_conciliado));

  return (
    <GlassCard intensity="low" p={4} mb={5}>
      <Flex align="center" justify="space-between" gap={3} mb={2} wrap="wrap">
        <Text fontSize="sm" fontWeight="700" color="#0F172A">
          Progresso da conciliação
        </Text>
        <Text fontSize="13px" color="#64748B" fontWeight="600">
          {pctConc}% por valor · {fmtValor(resumo.soma_pendente + resumo.soma_revisao)} a resolver
        </Text>
      </Flex>
      <Flex h="10px" borderRadius="full" overflow="hidden" bg="rgba(15, 23, 42, 0.06)" mb={2}>
        {SEG.map(s => {
          const w = pct(resumo[s.key]);
          if (w <= 0) return null;
          return (
            <Box
              key={s.key}
              w={`${w}%`}
              minW="4px"
              bgGradient={`linear(to-b, ${s.cor}CC, ${s.cor})`}
              transition="width 0.4s cubic-bezier(0.4,0,0.2,1)"
            />
          );
        })}
      </Flex>
      <Flex gap={4} wrap="wrap">
        {SEG.map(s => (
          <Flex key={s.key} align="center" gap={1.5}>
            <Box w="8px" h="8px" borderRadius="full" bg={s.cor} />
            <Text fontSize="11px" color="#64748B">
              {s.label}
            </Text>
            <Text fontSize="11px" color="#0F172A" fontWeight="700">
              {fmtValor(resumo[s.key])}
            </Text>
          </Flex>
        ))}
      </Flex>
    </GlassCard>
  );
}
